import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';

interface GroupProtectedRouteProps {
  requiredGroup: string;
  children: React.ReactNode;
}

export const GroupProtectedRoute: React.FC<GroupProtectedRouteProps> = ({
  requiredGroup,
  children,
}) => {
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const groups: string[] =
    (accounts[0]?.idTokenClaims as Record<string, unknown>)?.groups as string[] ?? [];

  if (!groups.includes(requiredGroup)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
